import fetch from '../../rest/card-delete';

export default fetch;
